import {
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment,
	OrderAdditionalServiceGdsServiceProduct
} from '@websky/graphql';

import { isPieceConceptBaggageWeight } from '@shared/lib/gdsService';

export const getActualProduct = (products?: OrderAdditionalServiceGdsServiceProduct[]) => {
	let actualProduct: OrderAdditionalServiceGdsServiceProduct = null;

	products?.forEach(product => {
		if (!actualProduct || actualProduct?.id < product.id) {
			actualProduct = product;
		}
	});

	return actualProduct;
};

export const getBaggageName = (service: GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment, count: number) => {
	const weight = isPieceConceptBaggageWeight(service.baggageWeight) ? '' : `, ${service.baggageWeight}`;

	return `${count}x ${service.name}${weight}`;
};

export const isShowInsurancesByPassengers = (mode: 'default' | 'aggregator') => {
	return mode === 'aggregator';
};
